export default __webpack_public_path__ + "static/media/attestation-guide.69eecd2b.png";